import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { formatTimeWithTimezone, getUserTimezone } from '../utils/timeUtils';
import JobHistory from '../components/history/JobHistory';
import './Dashboard.css';

const Dashboard = () => {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('overview');
  const accessDeniedMessage = location.state?.accessDenied || '';

  useEffect(() => {
    if (!accessDeniedMessage) {
      return;
    }

    // Clear one-time router state so message does not persist after reload/navigation.
    navigate(location.pathname, { replace: true, state: {} });
  }, [accessDeniedMessage, location.pathname, navigate]);

  return (
    <div className="dashboard">
      {accessDeniedMessage && (
        <div
          style={{
            marginBottom: 16,
            padding: '10px 12px',
            borderRadius: 8,
            border: '1px solid #f59e0b',
            background: '#fef3c7',
            color: '#92400e',
            fontWeight: 600,
          }}
        >
          {accessDeniedMessage}
        </div>
      )}
      <header>
        <h1>Control Center</h1>
        <p className="dashboard-subtitle">
          Review account activity, manage tiers, and keep your ObjGen automation pipelines running smoothly.
        </p>
      </header>

      <div className="dashboard-tabs">
        <button
          className={`dashboard-tab ${activeTab === 'overview' ? 'dashboard-tab--active' : ''}`}
          onClick={() => setActiveTab('overview')}
        >
          Overview
        </button>
        <button
          className={`dashboard-tab ${activeTab === 'history' ? 'dashboard-tab--active' : ''}`}
          onClick={() => setActiveTab('history')}
        >
          Job History
        </button>
      </div>

      <div className="dashboard-content">
        {activeTab === 'overview' && (
          <>
            <p>
              This area is reserved for authenticated users. From here you can extend the console with analytics, parameter
              guardrails, and audit insights tailored to your organization.
            </p>

            {user && (
              <div className="user-info">
                <h2>User Information</h2>
                <div className="user-info-grid">
                  <div className="user-info-item">
                    <strong>Username</strong>
                    <span>{user.username}</span>
                  </div>
                  <div className="user-info-item">
                    <strong>Email</strong>
                    <span>{user.email}</span>
                  </div>
                  <div className="user-info-item">
                    <strong>User Tier</strong>
                    <span className={`tier-badge tier-badge--${user.tier}`}>{user.tier}</span>
                  </div>
                  <div className="user-info-item">
                    <strong>Account Status</strong>
                    <span className={`status-badge ${user.is_active ? 'status-badge--active' : 'status-badge--inactive'}`}>
                      {user.is_active ? 'Active' : 'Inactive'}
                    </span>
                  </div>
                  {user.last_login && (
                    <div className="user-info-item">
                      <strong>Last Login</strong>
                      <span>{formatTimeWithTimezone(user.last_login)}</span>
                    </div>
                  )}
                  <div className="user-info-item">
                    <strong>Your Timezone</strong>
                    <span>{getUserTimezone()}</span>
                  </div>
                </div>
              </div>
            )}
          </>
        )}

        {activeTab === 'history' && <JobHistory />}
      </div>
    </div>
  );
};

export default Dashboard;
